import React from "react";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";

const PrivacyPolicy = () => {

    return (
        <>
            <Header />
            <section className="terms-page">

                <div className="terms-container">

                    <div className="terms-hero">

                        <span>PRIVACY POLICY</span>

                        <h1>
                            Privacy

                            Policy
                        </h1>

                        <p>
                            At AppVerseLabs, we respect your privacy and are committed
                            to protecting your personal information. This Privacy Policy
                            explains how we collect, use, store and safeguard your data
                            when you use our website and services.
                        </p>

                    </div>

                    <div className="terms-content">

                        <div className="terms-block">
                            <h2>Information We Collect</h2>

                            <p>
                                We may collect personal information such as your name,
                                email address, phone number, company details and project
                                requirements when you contact us or engage our services.
                            </p>
                        </div>

                        <div className="terms-block">
                            <h2>How We Use Information</h2>

                            <p>
                                We use collected information to provide our services,
                                communicate with clients, improve user experience and
                                respond to inquiries effectively.
                            </p>
                        </div>

                        <div className="terms-block">
                            <h2>Cookies & Tracking Technologies</h2>

                            <p>
                                Our website may use cookies and similar technologies to
                                improve functionality, analyze traffic and enhance the
                                overall browsing experience.
                            </p>
                        </div>

                        <div className="terms-block">
                            <h2>Data Security</h2>

                            <p>
                                We implement appropriate technical and organizational
                                security measures to protect your personal information
                                against unauthorized access, disclosure or misuse.
                            </p>
                        </div>

                        <div className="terms-block">
                            <h2>Third-Party Services</h2>

                            <p>
                                We may utilize trusted third-party providers for hosting,
                                analytics, communication and other operational services
                                necessary to deliver our solutions.
                            </p>
                        </div>

                        <div className="terms-block">
                            <h2>Data Sharing</h2>

                            <p>
                                AppVerseLabs does not sell, rent or trade your personal
                                information. Information may only be shared when required
                                to provide services or comply with legal obligations.
                            </p>
                        </div>

                        <div className="terms-block">
                            <h2>Your Rights</h2>

                            <p>
                                You have the right to request access, correction,
                                modification or deletion of your personal information
                                by contacting our team directly.
                            </p>
                        </div>

                        <div className="terms-block">
                            <h2>Policy Updates</h2>

                            <p>
                                We reserve the right to update this Privacy Policy at
                                any time. Any changes will be posted on this page with
                                an updated revision date.
                            </p>
                        </div>

                        <div className="terms-block">
                            <h2>Contact Information</h2>

                            <p>
                                If you have any questions regarding this Privacy Policy,
                                please contact us at hello@appverselabs.com.
                            </p>
                        </div>

                    </div>

                    <div className="terms-contact">

                        <h3>
                            Questions About Privacy?
                        </h3>

                        <p>
                            Contact our team if you have any concerns about how your
                            information is collected, stored or used.
                        </p>

                        <a href="mailto:hello@appverselabs.com">
                            hello@appverselabs.com
                        </a>

                    </div>

                </div>

            </section>

            <style>{`

                .terms-page{
                    padding:140px 24px;
                    background:#fff;
                }

                .terms-container{
                    max-width:1440px;
                    margin:auto;
                }

                .terms-hero{
                    text-align:center;
                    margin-bottom:90px;
                }

                .terms-hero span{
                    display:inline-block;
                    padding:10px 20px;
                    border-radius:999px;
                    background:rgba(232,33,42,.08);
                    color:#E8212A;
                    font-size:12px;
                    font-weight:700;
                    letter-spacing:1.5px;
                    margin-bottom:25px;
                }

                .terms-hero h1{
                    font-size:clamp(52px,8vw,80px);
                    line-height:.95;
                    margin-bottom:25px;
                    color:#111;
                    text-align: center;
                    letter-spacing:-3px;
                    font-family:'Syne',sans-serif;
                }

                .terms-hero p{
                    max-width:760px;
                    margin:auto;
                    color:#666;
                    font-size:18px;
                    text-align: center;
                    line-height:1.9;
                    font-family:'Plus Jakarta Sans',sans-serif;
                }

                .terms-content{
                    border-top:1px solid #eee;
                }

                .terms-block{
                    padding:38px 0;
                    border-bottom:1px solid #eee;
                }

                .terms-block h2{
                    font-size:32px;
                    margin-bottom:16px;
                    color:#111;
                    font-family:'Syne',sans-serif;
                    position:relative;
                    padding-left:20px;
                }

                .terms-block h2::before{
                    content:"";
                    position:absolute;
                    left:0;
                    top:7px;
                    width:5px;
                    height:32px;
                    border-radius:20px;
                    background:#E8212A;
                }

                .terms-block p{
                    color:#666;
                    font-size:16px;
                    line-height:1.9;
                    padding-left:20px;
                    font-family:'Plus Jakarta Sans',sans-serif;
                }

                .terms-contact{
                    margin-top:70px;
                    padding:50px;
                    border-radius:30px;
                    background:
                    linear-gradient(
                        135deg,
                        #E8212A,
                        #FF4D4D
                    );
                    color:#fff;
                    text-align:center;
                }

                .terms-contact h3{
                    font-size:40px;
                    margin-bottom:15px;
                    font-family:'Syne',sans-serif;
                        text-align: center;
                }

                .terms-contact p{
                    text-align: center;
                    max-width:600px;
                    margin:0 auto 20px;
                    line-height:1.8;
                }

                .terms-contact a{
                    color:#fff;
                    text-decoration:none;
                    font-size:20px;
                    font-weight:700;
                }

                @media(max-width:768px){

                    .terms-page{
                        padding:100px 18px;
                    }

                    .terms-block h2{
                        font-size:24px;
                    }

                    .terms-contact{
                        padding:35px 25px;
                    }

                    .terms-contact h3{
                        font-size:30px;
                    }

                }

            `}</style>


            <Footer />
        </>
    );
};

export default PrivacyPolicy;